/**
 * Error codes for Registration API
 */
module.exports = {
  UNVERIFIED_IDP_TEACHER_ACCOUNT: 'E-SHA-REG-IDPUT',
};
